import { makeStyles } from '@mui/styles';
import Lottie from 'lottie-react';
import animationData from '../../Assets/bookloader.json';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: 'rgba(0, 0, 0, 0.3) !important',
    zIndex: 99999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default function KenLoader() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Lottie animationData={animationData} loop style={{ width: '15vh', height: '15vh' }} />
    </div>
  );
}
